import type { Panel } from "../lib/right-panel-state";

/**
 * The side panel an employee may see: the agent panel, and the computer panel for a copy whose
 * policy enables the computer. The routine editor, group panels and import form belong to IT, so a
 * panel saved from an earlier session as one of those is treated as closed, and so is a computer
 * panel saved for a bot the employee may not use a computer on.
 */
export function employeeSafePanel(
  panel: Panel,
  canManageAgents: boolean,
  canUseComputer = false,
): Panel {
  if (canManageAgents || panel === "settings") return panel;
  if (panel === "computer" && canUseComputer) return panel;
  return null;
}
